export default __webpack_public_path__ + "static/media/loading.d7d4ff77.gif";